import { Injectable } from '@angular/core';
import { IID_GENERIC_OK } from '@common/interfaces/interfaceData';
import { Topics } from '@common/interfaces/topics';
import { ActionService } from '../action/action.service';
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { IID_Generic_OkQuery } from './genericOk.query';
import { IID_Generic_OkStore } from './genericOk.store';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';
@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.GENERIC_OK)
export class IID_Generic_OkService extends CrudService<IID_GENERIC_OK, IID_Generic_OkStore, IID_Generic_OkQuery> {
  constructor(
    protected store: IID_Generic_OkStore,
    public query: IID_Generic_OkQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy) {
    super(
      Topics.IID_GENERIC_OK,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }

}
